<template>
  <form class='mb-12'>
    <div class='grid lg:grid-cols-3 gap-5 lg:gap-10 mb-7'>
      <div v-if='typeLabel' key='facility-type_id'>
        <theme-select name='facility-type_id' :options='facilityTypes' v-model='facilityObj.type_id' v-validate="'required'" :label='typeLabel'></theme-select>
      </div>
      <div key='facility_length'>
        <theme-numeric name='facility_length' v-model='facilityObj.length' v-validate='`decimal:2|min_value:0`' :label='lengthLabel' placeholder='0'></theme-numeric>
      </div>
      <div key='facility_width'>
        <theme-numeric name='facility_width' v-model='facilityObj.width' v-validate='`decimal:2|min_value:0`' :label='widthLabel' placeholder='0'></theme-numeric>
      </div>
    </div>
    <div v-for='(dim, dIdx) in facilityObj.extra_dimensions' :key='"extra_dim_" + dIdx' class='grid lg:grid-cols-3 gap-5 lg:gap-10 mb-7'>
      <div>
        <theme-numeric :name='"facility_extra_length_" + dIdx' v-model='dim.length' v-validate='`decimal:2|min_value:0`' :label='lengthLabel' placeholder='0'></theme-numeric>
      </div>
      <div>
        <theme-numeric :name='"facility_extra_width_" + dIdx' v-model='dim.width' v-validate='`decimal:2|min_value:0`' :label='widthLabel' placeholder='0'></theme-numeric>
      </div>
      <div>
        <button type='button' class='calculate-price__remove-dim-btn' @click='removeExtraDimension(dIdx)'>{{ removeDimensionLabel }}</button>
      </div>
    </div>
    <div class='mb-7' key='add_dimension'>
      <button type='button' class='calculate-price__add-room-btn' @click='addExtraDimension'>+ {{ addDimensionLabel }}</button>
    </div>
    <div class='grid lg:grid-cols-2 gap-5 lg:gap-10 mb-7'>
      <div key='description_nl'>
        <theme-input v-model='facilityObj.description.nl' :label='descriptionLabel + ` Dutch`' :placeholder='descriptionLabel'></theme-input>
      </div>
      <div key='description_en'>
        <theme-input v-model='facilityObj.description.en' :label='descriptionLabel + ` English`' :placeholder='descriptionLabel'></theme-input>
      </div>
    </div>
    <div class='mb-7' key='bold'>
      <theme-checkboxes name='bold' v-model='facilityObj.bold' :options='{1:boldLabel}' is-single-checkbox></theme-checkboxes>
    </div>
    <div v-if='!typeLabel' key='inner-button'>
      <button @click='submitHandler' type='submit' class='theme-btn theme-btn--primary'>
        <i class='icon-plus' style='font-size: 20px;'></i>
        {{ submitButtonText }}
      </button>
    </div>
    <div v-if='typeLabel' key='outer-button'>
      <button @click='submitHandler' type='submit' class='theme-btn theme-btn--primary'>
        <i class='icon-plus' style='font-size: 20px;'></i>
        {{ submitButtonText }}
      </button>
    </div>
  </form>
</template>
<script>
  import VSelect from '../admin/components/VSelect.vue';
  import VTextfield from '../admin/components/VTextfield.vue';
  import VCheckboxes from '../admin/components/VCheckboxes.vue';
  import sweetalert from 'sweetalert';

  const emptyFacility = () => ({
    type_id: null,
    width: null,
    length: null,
    extra_dimensions: [],
    bold: null,
    description: {
      nl: null,
      en: null,
    },
  });

  export default {
    $_veeValidate: {
      validator: 'new',
    },
    data() {
      return {
        facilityObj: emptyFacility(),
      };
    },
    components: {
      VSelect,
      VTextfield,
      VCheckboxes,
    },
    props: {
      facility: {
        default: () => {},
        type: Object,
      },
      facilityTypes: {
        default: () => {},
        type: Object,
      },
      submitButtonText: {
        default: '',
        type: String,
      },
      typeLabel: {
        default: '',
        type: String,
      },
      lengthLabel: {
        default: '',
        type: String,
      },
      widthLabel: {
        default: '',
        type: String,
      },
      boldLabel: {
        default: '',
        type: String,
      },
      descriptionLabel: {
        default: '',
        type: String,
      },
      addDimensionLabel: {
        default: 'Lengte en breedte veld toevoegen',
        type: String,
      },
      removeDimensionLabel: {
        default: 'Verwijderen',
        type: String,
      },
      updateCallback: {
        default: () => Promise.resolve(true),
        type: Function,
      },
      submitCallback: {
        default: () => Promise.resolve(true),
        type: Function,
      },
      formType: {
        default: 'submit',
        type: String,
      },
    },
    methods: {
      addExtraDimension() {
        if (!this.facilityObj.extra_dimensions) {
          this.facilityObj.extra_dimensions = [];
        }
        this.facilityObj.extra_dimensions.push({ length: '', width: '' });
      },
      removeExtraDimension(idx) {
        this.facilityObj.extra_dimensions.splice(idx, 1);
      },
      scrollToNewForm() {
        let form = $('.custom-facility-form');
        let nav = $('.navbar-fixed');
        let margin = 156;
        if (nav.length > 0) {
          margin = nav.height() + 80;
        }
        let topPosition = $(form[form.length - 1]).offset().top - margin;
        $('html, body').animate({scrollTop: topPosition}, 700);
      },
      submitHandler(event) {
        let that = this;
        if (event) event.preventDefault();
        that.$validator.validateAll().then(isValid => {
          if (isValid) {
            if (that.formType == 'update') {
              that.updateCallback(that.facilityObj).then(shouldReset => {
                if (shouldReset) {
                  that.facilityObj = emptyFacility();
                  that.$validator.reset();
                }

              }, err => {

              });
            } else {
              that.submitCallback(that.facilityObj).then(shouldReset => {
                if (shouldReset) {
                  that.facilityObj = emptyFacility();
                  that.$validator.reset();
                  that.scrollToNewForm();
                }

              }, err => {

              });
            }
          } else {
            that.$root.$emit('validation-error', that.$validator.errors);
            sweetalert('Error', 'The form contain errors!', 'error');
          }
        }, error => {

        });
      },
      submitPageHandler(event) {
        let that = this;

        if (event) event.preventDefault();

        if (that.formType == 'update') {
          that.$validator.validateAll().then(isValid => {
            if (isValid) {
              that.updateCallback(that.facilityObj).then(shouldReset => {
                if (shouldReset) {
                  that.facilityObj = emptyFacility();
                  that.$validator.reset();
                }

              }, err => {

              });
            }
          });
        } else {
          if (that.facilityObj.type_id === undefined) return;
          that.$validator.validateAll().then(isValid => {
            if (isValid) {
              that.submitCallback(that.facilityObj).then(shouldReset => {
                if (shouldReset) {
                  that.facilityObj = emptyFacility();
                  that.$validator.reset();
                  that.scrollToNewForm();
                }

              }, err => {

              });
            }
          });
        }
      },
    },
    watch: {
      facility: (value) => {
        this.facilityObj = Object.assign({}, value);
      },
    },
    created() {
      if (this.facility.description && this.facility.description.nl && this.facility.description.en) {
        this.facilityObj = Object.assign({}, emptyFacility(), this.facility);
      } else {
        let description = this.facility.description;
        this.facilityObj = Object.assign({}, emptyFacility(), this.facility);
        this.facilityObj.description = {
          nl: description && description.nl !== undefined ? description.nl : description,
          en: description && description.en !== undefined ? description.nl : '',
        };
      }
      if (!this.facilityObj.extra_dimensions) this.facilityObj.extra_dimensions = [];
      this.$root.$on('updateLandlordAndSubscription', () => {
        this.submitPageHandler();
      });
    },
  };
</script>